module.exports = __webpack_public_path__ + "static/media/LibreCaslonDisplay-Regular.086c693f.ttf";